import { ThemeProvider } from "styled-components";
import { AppRoutes } from "./routes";
import theme, { FontsImport } from "./styles/theme";
import { BrowserRouter } from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import packageJson from "../package.json";

// Importando CSS do react-pdf
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

import { AuthProvider, NavContextProvider, SocketProvider } from "./contexts";
import CookieConsent from "./components/cookies-consent";
import { useEffect } from "react";
import permissionsStore from "./store/permissions";
function App() {
  const { clearAll } = permissionsStore();

  const clearLocalStorage = () => {
    // Salva os valores das chaves antes de limpar o localStorage
    const permissionStorage = localStorage.getItem("permission-storage");
    const puxaVersion = localStorage.getItem("PUXA_VERSION");
    localStorage.clear(); // Limpa o localStorage
    clearAll(); //limpa o store de permissões
    // Armazena a versão do package.json
    if (puxaVersion) {
      localStorage.setItem("PUXA_VERSION", puxaVersion);
    }

    if (permissionStorage) {
      localStorage.setItem("permission-storage", permissionStorage);
    }
  };
  const clearCookiesAndLocalStorage = () => {
    const cookies = document.cookie.split("; ");
    cookies.forEach((cookie) => {
      const [name] = cookie.split("=");
      if (name !== "cookie-consent") {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    });

    clearLocalStorage();
    window.location.reload();
  };

  useEffect(() => {
    initLocalStorage();
  }, []);

  const initLocalStorage = () => {
    const puxaVersion = localStorage.getItem("PUXA_VERSION");
    if (puxaVersion !== packageJson.version) {
      clearCookiesAndLocalStorage();
      localStorage.setItem("PUXA_VERSION", packageJson.version);
    }
  };

  return (
    <>
      <title>{"Puxa Capivara"}</title>
      <ToastContainer
        hideProgressBar={true}
        theme="light"
        position="top-right"
        transition={Slide}
      />
      <NavContextProvider>
        <AuthProvider>
          <SocketProvider>
            <ThemeProvider theme={theme}>
              <BrowserRouter>
                <FontsImport />
                <AppRoutes />
                <CookieConsent />
              </BrowserRouter>
            </ThemeProvider>
          </SocketProvider>
        </AuthProvider>
      </NavContextProvider>
    </>
  );
}

export default App;
